<template>
	<div class="booking-form__section">
		<div class="booking-form__section-wrapper">
			<oh-heading
				:caption="componentName"
				:anchor="componentKebab"
				:selection="headerSelect"
				:canVisible="canIIsVisible"
				@toggleVisibility="toggleVisibility"
			/>

			<transition-expand>
				<div class="booking-form__section-details booking-form__provider flex-horizontal b-line" v-if="isVisible">
					<div class="b__item" v-for="(barber, i) in barbers" :key="i">
						<label class="provider__wraper b__item-label flex-vertical">
							<input
								class="b__item-input"
								type="radio"
								:id="`barber_${i}`"
								name="barber"
								v-model="selected"
								:value="barber.id"
								@change="select(barber)"
							/>
							<!-- <img class="provider__profile-picture" :src="barber.photoUrl" alt="" /> -->
							<picture class="provider__profile-picture">
								<source v-if="barber.photoUrl" :srcset="barber.photoUrl" type="image/webp" />
								<source srcset="@/assets/img/assets/icon__user-big@2x.png" type="image/png" />
								<!-- <img v-if="barber.photoUrl" :src="barber.photoUrl" class="provider__profile-picture_data" /> -->
								<img src="@/assets/img/assets/icon__user-big@2x.png" class="provider__profile-picture_data" />
							</picture>
							<div class="provider__label flex-horizontal">
								<div class="provider-checkbox"></div>
								<div class="provider__header flex-vertical">
									<span class="provider__name heading-subtitle">{{ barber.name }}</span>
									<span class="provider__title content-default">{{ barber.rank }}</span>
								</div>
							</div>
						</label>
					</div>
				</div>
			</transition-expand>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex'
import bookingMixin from '../mixins/booking.mixin'
import OhHeading from './heading'

export default {
	name: 'Barber',

	mixins: [bookingMixin],

	components: { OhHeading },

	data() {
		return {
			barbers: [],
			selected: null,
		}
	},

	computed: {
		headerSelect() {
			if (this.booking.barber) return this.booking.barber.name
			if (this.selected) return this._.find(this.barbers, { id: this.selected }).name
			return ''
		},
	},

	methods: {
		...mapActions({ set: 'booking/setBarber' }),

		async select(barber) {
			await this.set(barber.id)
			this.nextStep()
		},

		async getData() {
			let { data } = await this.$http.get(`/bs/${this.booking.id}/barbers`)
			this.barbers = data.data
			this.selected = this.booking.barber?.id ?? null
		},
	},
}
</script>
